/**
 * Tokens de diseño compartidos para la landing pública de ALTAMA CONSULTING.
 */
export const COLORS = {
  bloombergBlue: "#2800D7",
  digitalBlue: "#0068FF",
  webOrange: "#FB8B1E",
  blackHeader: "#050608",

  bgPrimary: "#07021a",
  bgSecondary: "#0d0930",
  bgTertiary: "#130f42",

  lightSection: "#f2f4f8",
  lightSurface: "#ffffff",
  lightText: "#0b1428",
  lightMuted: "#4f5c75",
  lightBorder: "rgba(11,20,40,0.16)",

  textPrimary: "#f0f2ff",
  textSecondary: "#8892cc",
  textMuted: "#3d3f7a",

  borderSubtle: "rgba(40,0,215,0.18)",
  borderMedium: "rgba(0,104,255,0.28)",
  borderStrong: "rgba(0,104,255,0.6)",
  borderWarm: "rgba(251,139,30,0.45)",

  navIdle: "rgba(5,6,8,0.96)",
  navScrolled: "rgba(5,6,8,0.98)",
  scrimOverlay: "rgba(7,2,26,0.72)",
  badgeWarmBg: "rgba(251,139,30,0.12)",
  heroGridDot: "rgba(0,104,255,0.08)",
  heroGlow: "rgba(40,0,215,0.18)",

  shadowMockup: "0 40px 80px rgba(0,104,255,0.2)",
  shadowCard: "0 16px 48px rgba(0,104,255,0.12)",
  teamGradient: "linear-gradient(135deg, #130f42, #2800D7)",
};

/**
 * Familias tipográficas del sistema visual.
 *
 * `display` es la voz editorial de la marca: titulares y cifras de portada.
 * `heading` y `body` cargan la interfaz y el texto corrido.
 * `data` queda para cifras, etiquetas técnicas y meta-información.
 */
export const FONTS = {
  display: '"Source Serif 4", Georgia, "Times New Roman", serif',
  heading: 'Inter, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  body: 'Inter, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  data: '"JetBrains Mono", Consolas, "SFMono-Regular", Menlo, monospace',
};

/**
 * Valores de layout reutilizables.
 */
export const LAYOUT = {
  maxWidth: "1200px",
  navHeight: "76px",
  scrollOffset: "96px",
};
